import AlertComponent from '../../stories/molecules/alerts'
import {
  alertAlignVariantOptions,
  alertOrientationVariantOptions,
  alertVariantComponentOptions
} from '../../stories/molecules/alerts/constants'
import { useErrorStore } from '../../../zustand/error-boundary/use-error-boundary-store'
import { buttonVariantOptions } from '../../stories/atoms/button/constants'
import {
  ErrorDescriptionContainer,
  ErrorMessage,
  ErrorMessageContainer,
  ErrorStack
} from '../styled-components'
import { useIntl } from 'react-intl'
import { useBrowserStore } from '../../../zustand/browser-store/use-browser-store'
import { useHistory } from 'react-router-dom'
import { useIntercom } from 'react-use-intercom'

const ErrorAlert = () => {
  const { error, info, showError, clearError } = useErrorStore()
  const { isProdOrStaging } = useBrowserStore()
  const history = useHistory()
  const { show } = useIntercom()

  const { formatMessage } = useIntl()
  if (!showError || !error) return null

  const handleBack = () => {
    clearError()
    history.goBack()
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }

  const handleShowIntercom = () => {
    show()
  }

  const Message = () => (
    <ErrorMessageContainer>
      <ErrorMessage>{error?.message}</ErrorMessage>
      <ErrorDescriptionContainer>
        <ErrorStack>{error?.stack}</ErrorStack>
        <ErrorStack>{info?.componentStack}</ErrorStack>
      </ErrorDescriptionContainer>
    </ErrorMessageContainer>
  )

  const message = isProdOrStaging
    ? formatMessage({ id: 'error_boundary_description' })
    : <Message /> || 'Unknown Error'

  return (
    <AlertComponent
      variant={alertVariantComponentOptions.DANGER}
      title={formatMessage({ id: 'error_boundary_title' })}
      description={message}
      buttonOrientation={alertOrientationVariantOptions.STACKED}
      buttonAlignment={alertAlignVariantOptions.END}
      width="600px"
      actionButtons={[
        {
          variant: buttonVariantOptions['TERTIARY-HOLLOW'],
          onClick: handleShowIntercom,
          children: formatMessage({ id: 'error_boundary_contact_btn' }),
          fullWidth: true
        },
        {
          variant: buttonVariantOptions['SECONDARY-HOLLOW'],
          onClick: handleBack,
          children: formatMessage({ id: 'back' }),
          fullWidth: true
        }
      ]}
      style={{ zIndex: 9999 }}
    />
  )
}

export default ErrorAlert
